import { styled } from '@uhg-abyss/web/tools/styled';
import { Popover } from '@uhg-abyss/web/ui/Popover';

export const PremiumCareDrawerLinkStyle = {
  fontSize: '16px',
  'abyss-link-root': {
    marginTop: '16px',
    lineHeight: '20px',
    fontWeight: '700',
    padding: '8px 0',
  },
  'abyss-link-icon-wrapper': {
    marginLeft: '4px',
  },
  'abyss-link-icon': {
    height: '24px',
    width: '24px',
  },
};

export const PremiumCareDrawerStyles = {
  'abyss-modal-base-content-container': {
    borderRadius: '20px 20px 0 0',
    height: 'auto !important',
  },
  'abyss-modal-base-body': {
    margin: '16px 24px 16px 24px',
    color: '$core.color.neutral.90',
    whiteSpace: 'pre-line',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '20px',
  },
  'abyss-modal-close-button': { margin: '8px 10px 0 0' },
  'abyss-modal-content-title': {
    paddingTop: '0px',
    fontFamily: '$primary !important',
    fontSize: '20.25px !important',
    color: '#323334 !important',
    lineHeight: '24px !important',
    fontWeight: '700 !important',
  },
  'abyss-modal-header-container': {
    padding: '16px 24px 0px 24px',
  },
};

export const PremiumCarePopoverLinkStyle = {
  fontSize: '16px',
  'abyss-link-root': { lineHeight: '20px', fontWeight: '700', margin: '4px 0' },
  'abyss-link-icon-wrapper': {
    marginLeft: '4px',
  },
  'abyss-link-icon': {
    height: '24px',
    width: '24px',
  },
};

export const PremiumCareSnackCardPopoverStyles = styled(Popover, {
  display: 'flex',
  dynamic: ({ cssProps: { landingPage } = {} }) => ({
    '&.abyss-popover-trigger': {
      marginRight: 'auto',
      marginLeft: landingPage ? 'auto' : '12px',
    },
  }),
  '.abyss-popover-content-container': {
    whiteSpace: 'pre-line',
    color: '$core.color.neutral.90',
  },
  '&.abyss-popover-root': {
    borderTop: 0,
    borderBottom: 0,
  },
});

export const PremiumInfoBox = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '8px 8px 0px 0px',
  backgroundColor: '$core.color.brand.5',
  height: '24px',
  padding: ' 4px $sm ',
  minWidth: '120px',
  fontWeight: '700',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  variants: {
    isMultiple: {
      true: {
        '@media (min-width: 464px)': {
          maxWidth: '200px',
        },
        '@media (max-width: 464px)': {
          maxWidth: '117px',
        },
      },
      false: { maxWidth: '400px' },
    },
  },
  dynamic: ({ cssProps: { landingPage } = {} }) => ({
    '@media (max-width: 464px)': {
      marginRight: 'auto',
      marginLeft: landingPage ? 'auto' : '12px',
    },
  }),
});

export const PremiumInfoBoxText = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  backgroundColor: '$core.color.neutral.10',
  height: '20px',
  fontWeight: '700',
  marginLeft: '4px',
});
export const PremiumInfoBoxTextUMR = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  height: '20px',
  fontWeight: '700',
  marginLeft: '4px',
});

export const PremiumPopoverText = styled('div', {
  marginBottom: '8px',
});

export const PremiumInfoBoxUMR = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '8px 8px 0px 0px',
  backgroundColor: '$core.color.brand.5',
  height: '24px',
  padding: ' 4px $sm ',
  minWidth: '120px',
  fontWeight: '700',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  variants: {
    isMultiple: {
      true: {
        '@media (min-width: 464px)': {
          maxWidth: '200px',
        },
      },
      false: { maxWidth: '400px' },
    },
  },
  dynamic: ({ cssProps: { landingPage } = {} }) => ({
    '@media (max-width: 464px)': {
      marginRight: 'auto',
      marginLeft: landingPage ? 'auto' : '12px',
    },
  }),
});
